import { makeStyles, styled } from '@material-ui/core'
import { Check, CircleX } from 'components/icons'
import Tooltip from 'components/Tooltip'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { formatNumber } from 'utils/numbers'

const Container = styled('div')(({ theme }) => ({
  border: '1px solid #DFDFDF',
  borderRadius: 10,
  padding: 10,
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  userSelect: 'none',
  background: 'linear-gradient(#C9CEDB 0%, rgb(255, 255, 255) 30%)',
  color: '#525e7c',
}))

const UnitName = styled('h1')(() => ({
  color: '#525e7c',
  fontSize: 15,
  fontWeight: 'bold',
  margin: 0,
}))

const RegionName = styled('p')(() => ({
  color: '#0F3444',
  fontSize: 13,
  marginTop: 5,
  marginBottom: 10,
}))

const DMBTotalContainer = styled('div')(() => ({
  display: 'flex',
  gap: 10,
  alignItems: 'center',
}))

const DMBTotalLabel = styled('div')(() => ({
  color: '#0F3444',
  width: 40,
  lineHeight: 1,
  textAlign: 'center',
}))

const DMBValue = styled('div')(({ color }) => ({
  color: `${color}`,
  fontSize: 28,
  fontWeight: 'bold',
}))

const FooterContainer = styled('div')(() => ({
  fontSize: 11,
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  justifyContent: 'space-between',
}))

const Group = styled('div')(({ isNegative }) => ({
  color: isNegative ? '#e92833' : '#5c707b',
  display: 'flex',
  alignItems: 'center',
  gap: 5,
  background: isNegative ? '#fbf1f0' : 'transparent',
  borderRadius: 90,
  padding: '2px 6px',
}))

const useStyledTooltip = makeStyles(theme => ({
  arrow: {
    color: 'rgb(255,60,60)',
  },
  tooltip: {
    padding: theme.spacing(1, 2),
    backgroundColor: 'rgb(255,60,60)',
    borderRadius: 8,
    color: theme.palette.white.main,
    fontSize: theme.typography.pxToRem(12),
    fontWeight: 'bold',
  },
}))

export const UnitCard = ({ index = 0, unit = {} }) => {
  const { t, i18n } = useTranslation()
  const classes = useStyledTooltip()

  const displayErrorCheck = () => {
    if (unit.dmbTotal === 0) return false
    const hasFalse = [unit.validacaoDmb30, unit.validacaoDmb70].some(i => !i)
    if (hasFalse) return true
    if (unit.ecorregiao === 'Não possui')
      return true
    return false
  }

  const dmbValidation = dbmEmValidacao => {
    if (unit.dmbTotal === 0) return false
    if (dbmEmValidacao) return false
    return true
  }

  const getTooltipMessage = () => {
    if (unit.ecorregiao === 'Não possui')
      return t('creditosDeBiodiversidade.unidadeNaoPossuiEcoregiao')

    return ''
  }

  return (
    <Tooltip title={getTooltipMessage()} classes={classes}>
      <Container>
        <UnitName>{unit.nome}</UnitName>
        <RegionName>
          {t('creditosDeBiodiversidade.ecorregioao')}: {unit.ecorregiao === 'Não possui' ? t('creditosDeBiodiversidade.naoPossui') : unit.ecorregiao }
        </RegionName>

        <DMBTotalContainer>
          <DMBTotalLabel> {t('creditosDeBiodiversidade.DMBTotal')}</DMBTotalLabel>
          <DMBValue>{formatNumber(unit.dmbTotal, i18n.language)}</DMBValue>
          {displayErrorCheck() ? <CircleX /> : <Check />}
        </DMBTotalContainer>

        <FooterContainer>
          <Group isNegative={dmbValidation(unit.validacaoDmb30)}>
            <span>{formatNumber(unit.dmb30, i18n.language)}</span>
            <span style={{ whiteSpace: 'nowrap' }}>30% {t('creditosDeBiodiversidade.doDMB')}</span>
          </Group>

          <Group isNegative={dmbValidation(unit.validacaoDmb70)}>
            <span>{formatNumber(unit.dmb70, i18n.language)}</span>
            <span style={{ whiteSpace: 'nowrap' }}>70% {t('creditosDeBiodiversidade.doDMB')}</span>
          </Group>
        </FooterContainer>
      </Container>
    </Tooltip>
  )
}
